/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	Component,
	OnInit,
	OnDestroy,
	ChangeDetectionStrategy,
	forwardRef,
	Input,
	HostBinding,
	ViewEncapsulation,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { DefaultLoggerService, ILoggerService } from '@touchplan/logging';
import { LoggerServiceFactory } from '../../logging/LoggerServiceFactory';

@Component({
	selector: 'fancy-checkbox',
	templateUrl: './fancy-checkbox.component.html',
	styleUrls: ['./fancy-checkbox.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	// need this for now and should be removed when we have understanding and solution component style not working properly
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FancyCheckboxComponent),
			multi: true,
		},
		LoggerServiceFactory.provide('FancyCheckboxComponent'),
	],
})
export class FancyCheckboxComponent implements OnInit, OnDestroy, ControlValueAccessor {
	// override the standard class attr with ours to get its value and add our additional ones.
	@Input() public class = '';
	@HostBinding('class')
	get hostClasses(): string {
		return [
			this.class,
			['small-checkbox', 'medium-checkbox', 'large-checkbox'].find((item) => this.class.includes(item))
				? ''
				: 'small-checkbox',
		].join(' ');
	}

	public shutdownSubject = new Subject<void>();

	public internalCheckbox = new UntypedFormControl(false);

	// Both onChange and onTouched are functions
	public onChange: any = () => {};
	public onTouched: any = () => {};

	constructor(private logger: DefaultLoggerService) {}

	public ngOnInit() {
		this.internalCheckbox.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val) => {
			this.onChange(val);
			// this.internalCheckbox.setValue(val, {
			// 	emitEvent: false
			// });
		});
	}
	public ngOnDestroy() {
		this.shutdownSubject.next();
	}

	/**
	 * Writes a new value to the element.
	 */
	public writeValue(obj: any) {
		this.logger.log('writeValue', obj);
		// this.value = obj;
		this.internalCheckbox.setValue(obj);
	}
	/**
	 * Registers a callback function that should be called whenFancyFancyCheckboxComCheckboxCom
	 * the control's value changes in the UI.
	 */
	public registerOnChange(fn: any) {
		this.onChange = fn;
	}
	/**
	 * Registers a callback function that should be called when
	 * the control receives a blur event.
	 */
	public registerOnTouched(fn: any) {
		this.onTouched = fn;
	}
	/**
	 * This function is called by the forms API when
	 * the control status changes to or from "DISABLED".
	 */
	// setDisabledState?(isDisabled: boolean){
	//
	// }FancyCheckboxComponent
}
